import { useCallback, useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";

import { format } from "date-fns";

import {
  Background,
  CompromissoContainer,
  Container,
  Footer,
  HorariosContainer,
} from "./style.js";

import api from "../../services/api.js";
import Auth from "../../services/auth.js";

import RadioButton from "../../Components/RadioButton/index";

import local from "../../Assets/Images/location.png";

import Swal from "sweetalert2";
import InputMask from "@mona-health/react-input-mask";

const MeuAgendamento = () => {
  const navigate = useNavigate();
  const user = Auth.user();

  const [loading, setLoading] = useState(false);

  const [permitidoCancelar, setPermitidoCancelar] = useState(false);

  const [possuiAviso, setPossuiAviso] = useState(true);
  const [possuiAgendamento, setPossuiAgendamento] = useState(true);

  const [dataDoacao, setDataDoacao] = useState();
  const [idCalendario, setIdCalendario] = useState();
  const [horariosCalendario, setHorariosCalendario] = useState([]);

  const [data, setData] = useState([]);

  const fetchDataAviso = useCallback((cpf) => {
    setLoading(true);
    try {
      api.get(`/show-alerts?cpf_doador=${cpf}`).then((response) => {
        if (
          response?.data?.length <= 0 ||
          response?.data?.mensagem ===
            "O(s) Aviso(s) não foram encontrados ou já foram visualizados."
        ) {
          setPossuiAviso(false);
          setPossuiAgendamento(true);
        } else {
          Swal.fire({
            title: "Aviso",
            html: `
              ${
                response?.data[0].descricao1 &&
                `<p>${response?.data[0].descricao1}</p>`
              } 
              ${
                response?.data[0].descricao2 &&
                `<p>${response?.data[0].descricao2}</p>`
              }
            `,
            confirmButtonText: "OK",
            confirmButtonColor: "var(--red-color)",
          }).then((action) => {
            if (action) {
              const Ids = response?.data[0].id + " " + cpf;
              api
                .post(`/insert-alerts-viewed?ids=${Ids}`)
                .then(() => fetchDataAviso(cpf));
            }
          });
        }
      });
    } catch (error) {
      setPossuiAviso(false);
      setPossuiAgendamento(true);
    } finally {
      setLoading(false);
    }
  }, []);

  const fetchDataAgendamento = useCallback((cpf) => {
    setLoading(true);
    try {
      api
        .get(`/scheduling?cpf=${cpf}`)
        .then((response) => {
          if (response?.data.length === 0) {
            setPossuiAgendamento(false);
            setData([]);
          } else {
            setPossuiAgendamento(true);
            setData(response.data);
            setDataDoacao(response?.data[0]?.data_doacao);
            setIdCalendario(response?.data[0]?.id_calendario);
          }
        })
        .catch((error) => {
          console.log(error);
        });
    } catch (error) {
      console.log(error);
    } finally {
      setLoading(false);
    }
  }, []);

  const fetchDataCalendarioDoacoes = useCallback(() => {
    setLoading(true);
    try {
      api
        .get(`/calendars?open=${true}`)
        .then((response) => {
          if (response.data.error) {
            Swal.fire({
              title: "Atenção!",
              icon: "warning",
              html: `
                <h4>
                  O cadastro no sistema para a retirada da senha on-line estará disponivel 
                  na quinta-feira (a partir das 6h) que antecede a data da doação de
                  Sangue
                </h4>
                <h4>Acompanhe pelo calendário de Doação de Sangue ${new Date().getFullYear()} no link abaixo:</h4>
                <a href="https://www.fiec.com.br/site/noticia/2088/ver.do" target="_blank">Link do Calendário</a>
              `,
            }).then(() => {
              navigate("/");
            });
          } else {
            let possuiHorarios = false;
            response?.data?.calendarios?.forEach((calendario) => {
              calendario?.horarios?.forEach((horario) => {
                if (horario?.vagas > horario?.vagas_preenchidas) {
                  possuiHorarios = true;
                }
              });
            });

            setDataDoacao(response?.data?.calendarios[0]?.data_doacao);
            setIdCalendario(response?.data?.calendarios[0]?.id);
            setHorariosCalendario(response?.data?.calendarios[0]?.horarios);

            if (!possuiHorarios) {
              Swal.fire({
                title: "Aviso",
                html: `
                  <h2>Horários Esgotados</h2> 
                  <p>ATENÇÃO, apesar de as senhas terem esgotado é possível que algum doador realize o cancelamento do agendamento. Por isso, acompanhe as senhas disponíveis até o horário limite da inscrição.</p>
                  <a href="https://www.fiec.com.br/site/noticia/2088/ver.do" target="_blank">Confira o calendário de doação</a>
                `,
                confirmButtonText: "OK",
                confirmButtonColor: "var(--red-color)",
              }).then((action) => {
                if (action) {
                  navigate("/");
                }
              });
            }
          }
        })
        .catch((error) => {
          console.log(error);
          Swal.fire({
            title: "Falha!",
            icon: "error",
            text: "Falha na busca do calendário!",
            timer: 2000,
          }).then(() => {
            navigate("/");
          });
        });
    } catch (error) {
      console.log(error);
    } finally {
      setLoading(false);
    }
  }, [navigate]);

  const fetchDataPermissaoCancelarDoacao = useCallback(async () => {
    setLoading(true);
    try {
      api.get("/configs/permission-to-cancel-donation")
        .then((response) => {
          const raw = response.data;
          const valor = Array.isArray(raw)
            ? raw[0]?.permitir_cancelar_doacao
            : raw?.permitir_cancelar_doacao;
          setPermitidoCancelar(!!valor);
        })
        .catch((error) => {
          Swal.fire({
            title: "Atenção!",
            text: "Não foi possível carregar a configuração atual.",
            icon: "warning",
            confirmButtonColor: "var(--red-color)",
          });
        });
    } catch (error) {
      Swal.fire({
        title: "Atenção!",
        text: "Não foi possível carregar a configuração atual.",
        icon: "warning",
        confirmButtonColor: "var(--red-color)",
      });
    } finally {
      setLoading(false);
    } 
  }, [navigate]);

  // eslint-disable-next-line no-unused-vars
  async function handleCancel(id, cpf, horario) {
    try {
      if (!permitidoCancelar) {
        Swal.fire({
          title: "Aviso",
          icon: "warning",
          html: `
            <h4>O cancelamento de agendamento não está disponível.</h4>
            <p>Por favor, entre em contato com a equipe de suporte para mais informações.</p>
          `,
          confirmButtonText: "OK",
          confirmButtonColor: "var(--red-color)",
        });
        return;
      }
      if (
        new Date(dataDoacao).toDateString() === new Date().toDateString() &&
        new Date().getHours() >= 9
      ) {
        Swal.fire({
          title: "Aviso",
          icon: "warning",
          html: `
            <strong>Não é permitido cancelar o agendamento depois das 9h do dia da doação.</strong>
          `,
          confirmButtonText: "OK",
          confirmButtonColor: "var(--red-color)",
        });
      } else {
        Swal.fire({
          title: "ATENÇÃO!",
          icon: "warning",
          showDenyButton: true,
          confirmButtonColor: "var(--red-color)",
          denyButtonColor: "var(--red-color)",
          html: `
            <strong>Entendemos que nem sempre é possível, mas ao cancelar sua doação, você perde a oportunidade de salvar até quatro vidas. Se não puder comparecer agora, lembre-se: no próximo mês, você pode ser a diferença que alguém precisa para continuar vivendo.</strong>
            <p>Tem certeza que deseja cancelar o agendamento?</p>
          `,
          confirmButtonText: "Sim",
          denyButtonText: "Não",
        }).then(async (result) => {
          if (result.isConfirmed) {
            api
              .get(`/cancel-scheduling?id=${id}&cpf=${cpf}&horario=${horario}&cpf_usuario=${user?.cpf}`)
              .then((response) => {
                Swal.fire({
                  text: `Se necessário agende um novo horário!`,
                  icon: "warning",
                  confirmButtonColor: "var(--red-color)",
                  confirmButtonText: "Ok",
                }).then(async (result) => {
                  fetchDataAgendamento(cpf);
                });
              })
              .catch((error) => {
                console.log(error, );
                Swal.fire({
                  title: "Falha!",
                  icon: "error",
                  html: `
                    <h4>${error?.response?.data?.error || "Falha ao cancelar o agendamento!"}</h4>
                    <p>Por favor, entre em contato com a equipe de suporte para mais informações.</p>
                  `,
                  confirmButtonText: "OK",
                  confirmButtonColor: "var(--red-color)",
                });
              });

            // await api.get(
            //   `/cancel-scheduling?id=${id}&cpf=${cpf}&horario=${horario}&cpf_usuario=${user?.cpf}`
            // );
            // Swal.fire({
            //   text: `Se necessário agende um novo horário!`,
            //   icon: "warning",
            //   confirmButtonColor: "var(--red-color)",
            //   confirmButtonText: "Ok",
            // }).then(async (result) => {
            //   fetchDataAgendamento(cpf);
            // });
          }
        });
      }
    } catch (error) {
      console.log(error);
    }
  }

  useEffect(() => {
    if (possuiAviso === true) {
      fetchDataAviso(user?.cpf);
    }
    if (possuiAgendamento === true) {
      fetchDataAgendamento(user?.cpf);
      fetchDataPermissaoCancelarDoacao();
    } else if (possuiAgendamento === false) {
      fetchDataCalendarioDoacoes(user?.cpf);
    }
  }, [
    user?.cpf,
    possuiAviso,
    possuiAgendamento,
    fetchDataAviso,
    fetchDataCalendarioDoacoes,
    fetchDataAgendamento,
    fetchDataPermissaoCancelarDoacao,
  ]);

  if (loading) {
    return (
      <Background>
        <h1>Carregando...</h1>
      </Background>
    );
  } else {
    if (data && data.length === 0) {
      return (
        <Background>
          <Container>
            <h1>Horários disponíveis para Agendamento</h1>
            <strong>{dataDoacao && dataDoacao}</strong>
            <legend>Selecione o horário e confirme:</legend>
            <HorariosContainer>
              <RadioButton
                doador={user}
                idCalendario={idCalendario}
                horariosCalendario={horariosCalendario}
                fetchDataAgendamento={fetchDataAgendamento}
              />
            </HorariosContainer>
            <Footer>
              <p>Local de Doação:</p>
              <a
                style={{
                  textDecoration: "none",
                  color: "gray",
                  fontWeight: "bold",
                  fontSize: "19px",
                  paddingTop: "2.4px",
                }}
                href="https://goo.gl/maps/zmn65JvzUzY8GsYK8"
                target="_blank"
                rel="noreferrer"
              >
                <img src={local} alt="Erro" />
                FIEC I{/* Espaço Bem Viver Mario Jacinto da Silva */}
              </a>
            </Footer>
          </Container>
        </Background>
      );
    } else if (data && data.length > 0) {
      return (
        <>
          <Background>
            <Container>
              <h1>Agendamento Ativo</h1>
              <CompromissoContainer>
                <label htmlFor="donation-date">Dia da Doação</label>
                <InputMask
                  id="donation-date"
                  type="text"
                  mask="99/99/9999"
                  disabled
                  value={format(new Date(data[0].data_doacao), "dd/MM/yyyy")}
                />
                <label htmlFor="donation-hour">Horário da Doação</label>
                <InputMask
                  id="donation-hour"
                  type="text"
                  mask="99:99"
                  disabled
                  value={data[0].horario_doacao}
                />
                {permitidoCancelar && (
                  <button
                    type="button"
                    disabled={!permitidoCancelar}
                    onClick={() =>
                      handleCancel(
                        data[0].id_calendario,
                        data[0].cpf_doador,
                        data[0].horario_doacao
                      )
                    }
                  >
                    CANCELAR este Agendamento
                  </button>
                )}
              </CompromissoContainer>
            </Container>
          </Background>
        </>
      );
    } else {
      return <Background></Background>;
    }
  }
};
export default MeuAgendamento;
